import ContentBlock from '../ContentBlock';
import ImageLink from '../ImageLink';

const mock = {
	...ContentBlock.Mock,
	...ImageLink.Mock,
};

export default mock;
